import { InputAdornment } from '@mui/material'
import { SxProps, Theme } from '@mui/system'
import React, { FC, useEffect, useState } from 'react'
import FormInput from '../FormInput/FormInput'
interface InputProps {
  label: string
  id?: string
  name: string
  classes?: string
  defaultValue?: string | number | undefined
  disabled?: boolean
  value?: any
  onChange?: any
  helperText?: any
  sx?: SxProps<Theme>
}
const formatValue = (value: string | number | undefined) => {
  if (value === undefined) return ''
  if (typeof value === 'number') return Number(value).toFixed(2)
  if (typeof value === 'string') return Number(value).toFixed(2)
  return value
}

export const calcValue = (fieldValue: string, percent?: number | undefined) => {
  const formValue = +fieldValue

  if (percent) {
    const value = ((percent || 0) / 100) * formValue + formValue
    return Number(value).toFixed(2)
  }
  if (formValue) {
    // console.log('val ', Number(formValue).toFixed(2))
    return Number(formValue).toFixed(2)
  }
  return
}

const CurrencyInput: FC<InputProps> = (props) => {
  const {
    id,
    label,
    name,
    classes,
    defaultValue,
    disabled = false,
    onChange,
    helperText,
    sx,
  } = props
  const [value, setValue] = useState<string | number | undefined>()

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <>
      {value && (
        <FormInput
          id={id}
          label={label}
          name={name}
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
          }}
          type="tel"
          className={classes}
          value={formatValue(value)}
          disabled={!!disabled}
          defaultValue={defaultValue}
          helperText={helperText}
          sx={sx}
        />
      )}
      {!value && (
        <FormInput
          name={name}
          id={id}
          label={label}
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
          }}
          type="tel"
          className={classes}
          defaultValue={formatValue(value)}
          disabled={!!disabled}
          onChange={onChange}
          helperText={helperText}
          sx={sx}
        />
      )}
    </>
  )
}

export default CurrencyInput
